exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "h2[data-v-d9103d0e]{position:relative;font-size:18px;font-weight:700;color:#666;margin:20px 0;white-space:nowrap;overflow:hidden}h2[data-v-d9103d0e]:after{content:\"\";display:inline-block;height:1px;width:100%;background:#fcfcfc;vertical-align:middle;margin-left:20px;box-shadow:0 -1px 0 #d8d8d8}", ""]);

